<template>
  <div class="containter">
    <div class="h-bg">
      <div class="header-box">
        <div class="header-box-left">
          <div class="top-time">
            <el-image style="width: 26px; height: 25px;margin-right: 9px;margin-left: 20px;"
                      :src="require('@/assets/images/header/dateTime.png')" fit="cover"></el-image>
            <div>
              <div class="f11">{{ nowTimeDay }}</div>
              <div class="f16" style="letter-spacing:2px">{{ nowTimeSecond }}</div>
            </div>
          </div>
          <el-button class="top-btn" @click="goto('/enterprise/PatentStatisticalAnalysis')"
                     :class="['btn-item',{'active':headerBtn==='/enterprise/PatentStatisticalAnalysis'}]">专利统计分析
          </el-button>
          <!-- <el-button class="top-btn" @click="goto('/enterprise/operationAnalysis')"
                     :class="['btn-item',{'active':headerBtn==='/enterprise/operationAnalysis'}]">
            运营分析
          </el-button> -->
        </div>
        <div class="title f40" v-if="isWidth" style="cursor: pointer;" @click="goto('/enterprise/EnterpriseStatisticalAnalysis')">天津市军民融合科技创新知识产权数字化平台</div>
        <div class="title f40" style="height: 80px;line-height: 80px;text-align: center;" v-else>
          <div style="height: 50px;line-height: 50px; font-size:28px;cursor: pointer;" @click="goto('/enterprise/EnterpriseStatisticalAnalysis')">天津市军民融合科技创新</div>
          <div style="height: 30px;line-height: 30px;font-size: 26px;cursor: pointer;" @click="goto('/enterprise/EnterpriseStatisticalAnalysis')">知识产权数字化平台</div>
        </div>
        <div class="header-box-right">
          <el-button class="top-btn" @click="goto('/enterprise/PatentValueAnalysis')"
                     :class="['btn-item',{'active':headerBtn==='/enterprise/PatentValueAnalysis'}]">专利价值分析
          </el-button>
          <!-- <el-button class="top-btn" @click="goto('/enterprise/ClassificationManagement')"
                     :class="['btn-item',{'active':headerBtn==='/enterprise/ClassificationManagement'}]">分类管理
          </el-button> -->
          <div @click="fullScreen" class="fullbtn">
<!--            <template v-if="isFullscreen">-->
<!--              <img src="@/assets/images/header/outfull.png" alt="">退出全屏-->
<!--            </template>-->
<!--            <template v-else>-->
<!--              <img src="@/assets/images/header/infull.png" alt="">全屏显示-->
<!--            </template>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapGetters, mapActions} from "vuex";
import Search from '@/components/common/search.vue'
import {storePersistKey} from "@/plugins/tools/Constant";
import {errorToast, successToast} from "@/plugins/tools/util";
import screenfull from "screenfull/dist/screenfull"

export default {
  props: [],
  watch: {
    $route: {
      immediate: true, // 一旦监听到路由的变化立即执行
      // 深度观察监听
      deep: true,
      handler(to, from) {
        console.log('to', to)
        const path = to.path
        this.headerBtn = path;// '/' + path.split('/')[1] + '/' + path.split('/')[2]
      },
    }
  },
  components: {
     Search
  },
  computed: {
    ...mapGetters({
      token: "userStore/token",
      userName: "userStore/userName",
      userId: "userStore/userId",
    }),
  },
  mounted() {
    this.getNowTime()
    clearInterval(myTimeDisplay)
    var myTimeDisplay = setInterval(() => {
      this.getNowTime()
    }, 1000)
    this.init()
    this.onresize()
    window.addEventListener('resize', this.onresize)
  },
  data() {
    return {
      nowTimeDay: '',
      nowTimeSecond: '',
      headerBtn: '',//一级路由
      isFullscreen:false,
      isWidth: true
    }

  },
  destroy () {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.fullChange)
    }
  },
  created() {

  },
  methods: {
    onresize(){
      this.isWidth = window.innerWidth > 1650
    },
    getNowTime() {
      var date = new Date()
      let days = ['一', '二', '三', '四', '五', '六', '日']
      var nowTimeDay = date.getFullYear() + '/' + this.addZero(date.getMonth() + 1) + '/'
        + this.addZero(date.getDate()) + ' 周' + (date.getDay()==0?'日':days[date.getDay() - 1])
      var nowTimeSecond = this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()) + ':'
        + this.addZero(date.getSeconds())
      this.nowTimeDay = nowTimeDay
      this.nowTimeSecond = nowTimeSecond
    },
    addZero(s) {
      return s < 10 ? ('0' + s) : s
    },
    goto(path) {
      this.$router.push({
        path
      })
    },
    //退出登录
    logout() {
      this.$cookies.remove('token')
      localStorage.removeItem(storePersistKey)
      this.$store.dispatch('userStore/clearToken')
      successToast("退出登录成功")
      this.$router.push({path: '/'})
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.fullChange)
      }
    },
    fullChange () {
      console.log(1111111,screenfull.isFullscreen)
      this.isFullscreen = screenfull.isFullscreen
    },
    //切换
    fullScreen () {
      if (!screenfull.isEnabled) {
        return false
      }
      //全屏
      screenfull.toggle();
    },
  }
}

</script>

<style scoped lang="scss">
.h-bg {
  height: 112px;
  width: 100%;
  background: url(~@/assets/images/header/h-bg.png) center/cover;
  background-size: 1440px 112px;
  background-repeat: no-repeat;
  background-clip: border-box;
  position: relative;
  z-index: 1000;
  overflow: hidden;

  &::after{
    content: '';
    width: 100%;
    height: 112px;
    position: absolute;
    background: url(~@/assets/images/header/h-bg.png);
    background-size: 1440px 112px;
    background-repeat: no-repeat;
    top: 0px;
    left: calc(50% + 720px);
    z-index: -1;
  }

  &::before{
    content: '';
    width: 100%;
    height: 112px;
    position: absolute;
    background: url(~@/assets/images/header/h-bg.png) right;
    background-size: 1440px 112px;
    background-repeat: no-repeat;
    top: 0px;
    right: calc(50% + 720px);
    z-index: -1;
  }

  .header-box {
    @include flex(space-around);
    height: 80px;

    .header-box-left,.header-box-right{
      width: 580px;
      @include flex(flex-start);
    }
    .btn-item {
      width: 120px;
      height: 34px;

      &.active {
        color: $mainColor-active;
        border-color: $mainColor-active;
        font-weight: bold;
        box-shadow: inset 0px 0px 10px 0px rgba(248, 197, 100, .7);
      }
    }

    .fullbtn {
      @include flex();
      color: #23E9FD;
      cursor: pointer;
      font-size: 16px;
      margin-left: auto;

      img {
        height: 32px;
        width: 32px;
        margin-right: 8px
      }
    }

    .top-time {
      @include flex();
      color: #23E9FD;
      flex-shrink: 0;
      margin-right: auto;
    }
    .top-btn{
      margin: 0 18px;
    }
    .title {
      flex-shrink: 0;
      height: 40px;
      font-family: AliHeavy;
      color: rgba(0, 0, 0, 0.65);
      line-height: 40px;
      //text-shadow: 0px 0px 16px rgba(0, 150, 255, 0.7), 0px 2px 2px rgba(0, 0, 0, 0.8);
      background: linear-gradient(360deg, #008CDC 0%, #02FEFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
/deep/ .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

/deep/ .el-input__icon {
    height: 34px;
    line-height: 34px;
  }

</style>



// WEBPACK FOOTER //
// src/layout/components/header.vue